
import Vue from 'vue';
import ChevronUp from '@carbon/icons-vue/es/chevron--up/16';
import ChevronDown from '@carbon/icons-vue/es/chevron--down/16';
import { mixin as clickaway } from 'vue-clickaway';
import { PmsColor } from '@midocean/webapps-shared-domain';

export default Vue.extend({
  name: 'ColorManagement',
  components: {
    ChevronDown,
    ChevronUp,
  },
  props: {
    selectedColor: {
      type: Object as () => PmsColor,
      required: true,
    },
    itemList: {
      type: Array as () => PmsColor[],
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
    },
  },
  mixins: [clickaway],
  data() {
    return {
      isOpen: false,
      inputValue: this.selectedColor.name,
      sortedList: this.itemList,
    };
  },
  watch: {
    inputValue(newValue) {
      if (this.isOpen) {
        this.sortItems(newValue.toLowerCase());
      }
    },
  },
  methods: {
    toggleDropdown(classList: DOMTokenList) {
      if (!classList.contains('toggler__search-box')) {
        this.isOpen = !this.isOpen;
        if (this.isOpen === false) {
          this.sortedList = this.itemList;
          this.inputValue = this.selectedColor.name;
        } else {
          const searchRef = this.$refs.searchColor as any;
          this.$nextTick(() => searchRef.focus());
          this.inputValue = '';
        }
      }
    },
    onClickAway() {
      if (this.disabled) return;
      this.isOpen = false;
      this.sortedList = this.itemList;
      this.inputValue = this.selectedColor.name;
    },
    sortItems(value: string) {
      this.sortedList = this.itemList.filter((c) =>
        c.name.toLowerCase().includes(value)
      );
    },
    replaceWith(colorName: string) {
      if (this.disabled) return;
      if (this.selectedColor.name === colorName) {
        return;
      }
      this.$emit('replace-with', colorName);
    },
  },
});
